import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import React from 'react';

export const generateCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  return createCommand('generate')
    .description('Generate a new extension for your project')
    .action(async (options, command) => {
      const { GenerateCommand } = await import(
        '../components/GenerateCommand/index.js'
      );
      const { renderCommand } = await import('./render-command.js');
      await renderCommand(command, services, cliVersion, <GenerateCommand />);
    });
};
